(function () {
  'use strict';
  // Home CMS rail — lazy tabs (perf 2026-09-09).
  //
  // snippets/eros-cms-collection-list.liquid server-renders only the selected
  // tab's cards; every other tab ships skeletons + a hidden crawlable link
  // list and carries data-eros-lazy-tab. On first selection this fetches the
  // tab's cards from sections/eros-collist-tab.liquid via Section Rendering
  // (/collections/<handle>?section_id=eros-collist-tab) and swaps them in —
  // the same fetch-and-import pattern as eros-plp-infinite.js, including the
  // eros:content-loaded re-bind event that quick-add (+) and friends listen
  // for; wishlist hearts are re-synced through the ErosWishlist API.
  //
  // Selection is observed two ways: Prestige's carousel fires `carousel:change`
  // ({ detail.index }) on <featured-collections-carousel>, and — to start the
  // fetch ~100ms earlier, before the click's switch animation — the tab
  // button's pointerdown. Both funnel into hydrate(), which is idempotent.
  var SECTION_ID = 'eros-collist-tab';
  var inflight = Object.create(null);

  function itemsOf(carousel) {
    return Array.prototype.slice.call(carousel.querySelectorAll('.featured-collections-carousel__item'));
  }

  function hydrate(item) {
    if (!item || !item.hasAttribute('data-eros-lazy-tab')) return;
    var handle = item.getAttribute('data-eros-collection');
    var limit = parseInt(item.getAttribute('data-eros-limit') || '12', 10) || 12;
    var list = item.querySelector('product-list');
    if (!handle || !list || inflight[handle]) return;
    inflight[handle] = true;

    var url = '/collections/' + encodeURIComponent(handle) + '?section_id=' + SECTION_ID;
    fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('http_' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var remote = doc.querySelector('[data-eros-collist-tab]');
        if (!remote) throw new Error('no_list');

        var cards = Array.prototype.slice.call(remote.children).slice(0, limit);
        var more = list.querySelector('.eros-cms-collist__more');
        var inserted = [];

        Array.prototype.forEach.call(list.querySelectorAll('[data-eros-skeleton]'), function (n) {
          n.remove();
        });
        cards.forEach(function (card) {
          var node = document.importNode(card, true);
          if (more) list.insertBefore(node, more);
          else list.appendChild(node);
          inserted.push(node);
        });

        item.removeAttribute('data-eros-lazy-tab');
        var seo = item.querySelector('.eros-cms-collist__seo');
        if (seo) seo.remove();

        inserted.forEach(function (node) {
          document.dispatchEvent(new CustomEvent('eros:content-loaded', { bubbles: true, detail: { root: node } }));
        });
        if (window.ErosWishlist && typeof window.ErosWishlist.syncToggles === 'function') {
          window.ErosWishlist.syncToggles(item);
        }
      })
      .catch(function () {
        // Keep the skeletons; the next selection retries.
        inflight[handle] = false;
      });
  }

  function bind(carousel) {
    carousel.addEventListener('carousel:change', function (e) {
      var index = e && e.detail ? e.detail.index : -1;
      if (index >= 0) hydrate(itemsOf(carousel)[index]);
    });

    var nav = carousel.id
      ? document.querySelector('carousel-navigation[aria-controls="' + carousel.id + '"]')
      : null;
    if (!nav) return;
    nav.addEventListener(
      'pointerdown',
      function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('button') : null;
        if (!btn) return;
        var index = Array.prototype.indexOf.call(nav.querySelectorAll('button'), btn);
        if (index >= 0) hydrate(itemsOf(carousel)[index]);
      },
      { passive: true }
    );
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('featured-collections-carousel'), function (carousel) {
      if (carousel.querySelector('[data-eros-lazy-tab]')) bind(carousel);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
